import { render, staticRenderFns } from "./JoinMemberForm.vue?vue&type=template&id=23ae2550&scoped=true"
import script from "./JoinMemberForm.vue?vue&type=script&lang=js"
export * from "./JoinMemberForm.vue?vue&type=script&lang=js"
import style0 from "./JoinMemberForm.vue?vue&type=style&index=0&id=23ae2550&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ae2550",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23ae2550')) {
      api.createRecord('23ae2550', component.options)
    } else {
      api.reload('23ae2550', component.options)
    }
    module.hot.accept("./JoinMemberForm.vue?vue&type=template&id=23ae2550&scoped=true", function () {
      api.rerender('23ae2550', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/user/JoinMemberForm.vue"
export default component.exports